module.exports = __webpack_public_path__ + "img/Jump Casting122.57e2961c.jpg";